module.exports = "\r\n.bg {\r\n  /* The image used */\r\n  background-image: url(\"/assets/imgs/A36FFD24.PNG\");\r\n\r\n  /* Full height */\r\n  position: absolute;\r\n  top:0;\r\n  left:0;\r\n  right:0;\r\n  bottom:0;\r\n\r\n  /* Center and scale the image nicely */\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/unavailable/unavailable.component.css
// module id = ./src/app/unavailable/unavailable.component.css
// module chunks = main